import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { LoadingIcon } from '../../assets/Icons';

function UpButton({
  loading,
  disabled,
  children,
  onClick,
  className = '',
}: {
  loading?: boolean;
  disabled?: boolean;
  children: ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
}) {
  function handleButtonClick(e: React.MouseEvent<HTMLButtonElement>) {
    if (!onClick || loading || disabled) return;
    onClick(e);
  }

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={handleButtonClick}
      className={twMerge(
        'bg-brand-background text-brand-text p-4 font-bold w-full text-center rounded-xl block mx-auto',
        onClick && 'cursor-pointer',
        disabled && 'cursor-not-allowed bg-up-black-20 text-white',
        className,
      )}>
      {loading ? (
        <LoadingIcon className="w-5 h-5 text-brand-icon mx-auto" />
      ) : (
        <div className="leading-5 mx-auto">{children}</div>
      )}
    </button>
  );
}

export default UpButton;
